import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import PropTypes from 'prop-types';
import adapter from '../../adapter';
import './index.css';
export default function visualDomFactory() {
  var _VisualDom;
  var _adapter$getRuntime = adapter.getRuntime(),
    PureComponent = _adapter$getRuntime.PureComponent,
    createElement = _adapter$getRuntime.createElement;
  return _VisualDom = /*#__PURE__*/function (_PureComponent) {
    _inheritsLoose(VisualDom, _PureComponent);
    function VisualDom() {
      return _PureComponent.apply(this, arguments) || this;
    }
    var _proto = VisualDom.prototype;
    _proto.render = function render() {
      var _this$props = this.props,
        children = _this$props.children,
        cell = _this$props.cell,
        title = _this$props.title,
        label = _this$props.label,
        text = _this$props.text,
        __componentName = _this$props.__componentName;
      var mainContent = children;
      if (cell && typeof cell === 'function') {
        mainContent = cell();
      }
      return createElement('div', {
        className: 'visual-dom'
      }, createElement('div', {
        className: 'panel-container'
      }, [createElement('span', {
        className: 'title'
      }, title || label || text || __componentName), createElement('div', {
        className: 'content'
      }, mainContent)]));
    };
    return VisualDom;
  }(PureComponent), _VisualDom.displayName = 'VisualDom', _VisualDom.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
  }, _VisualDom.defaultProps = {
    children: null
  }, _VisualDom;
}